export const COMMON_SERVICES = {
    Amplify: Symbol.for('Amplify'),
    AuthService: Symbol.for('AuthService'),
    CoreEventDispatcher: Symbol.for('CoreEventDispatcher'),
    AnalyticsService: Symbol.for('AnalyticsService'),
    ConfigService: Symbol.for('ConfigService'),
    NoticeStore: Symbol.for('NoticeStore'),
};
